import"../../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../../icon-registry.js";const p=i("flag-tz-tanzania",l`
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5982_15067)">
<path d="M2 6.5C2 5.39543 2.89543 4.5 4 4.5H20C21.1046 4.5 22 5.39543 22 6.5V17.5C22 18.6046 21.1046 19.5 20 19.5H4C2.89543 19.5 2 18.6046 2 17.5V6.5Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5V19.5H22V4.5H2Z" fill="#3195F9"/>
<mask id="mask0_5982_15067" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="4" width="20" height="16">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5V19.5H22V4.5H2Z" fill="white"/>
</mask>
<g mask="url(#mask0_5982_15067)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5V19.5L22 4.5H2Z" fill="#73BE4A"/>
<path d="M0.861662 20.3995L1.29539 21.0493L1.94518 20.6156L24.6083 5.48842L25.2581 5.05469L24.8243 4.4049L23.4364 2.32555L23.0027 1.67576L22.3529 2.10948L-0.310191 17.2367L-0.959985 17.6704L-0.52626 18.3202L0.861662 20.3995Z" fill="#272727" stroke="#FFD018" stroke-width="1.5625"/>
</g>
</g>
<path d="M4 4C2.61929 4 1.5 5.11929 1.5 6.5V17.5C1.5 18.8807 2.61929 20 4 20H20C21.3807 20 22.5 18.8807 22.5 17.5V6.5C22.5 5.11929 21.3807 4 20 4H4Z" stroke="#BFBFBF"/>
<defs>
<clipPath id="clip0_5982_15067">
<path d="M2 6.5C2 5.39543 2.89543 4.5 4 4.5H20C21.1046 4.5 22 5.39543 22 6.5V17.5C22 18.6046 21.1046 19.5 20 19.5H4C2.89543 19.5 2 18.6046 2 17.5V6.5Z" fill="white"/>
</clipPath>
</defs>
</svg>

    `);export{p as FlagTzTanzania};
